// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2f55P","infoBtn":"quickbooks_infoBtn__2j7Vm","formBox":"quickbooks_formBox__qY7Bu","formFooter":"quickbooks_formFooter__MP2m-"};